export default function(state = this.initialValue, action) {
    switch (action.type) {
        case this.selectedAction:
            return action.payload.data;
        default:
            return state;
    }
}